import React from "react";
import { useTranslation } from "react-i18next";
import "moment/locale/pt-br";

import { Box } from "@mui/system";
import Typography from "@mui/material/Typography";
import { Icon } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useStyles } from "../../styles/index.styles";
import palette from "../../../common/styles/palette";

interface ListItemProps {
  title?: any;
  description?: any;
  btnVariant?: "info" | "warning" | "primary" | "secondary";
  btnTitle?: any;
  urlClick?: any;
  status_event_ended?: boolean;
  iconName?: string;
}

export function ListItem({
  title,
  description,
  iconName,
  btnVariant = "primary",
  btnTitle,
  urlClick,
  status_event_ended,
}: ListItemProps) {
  const styles = useStyles();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleClickButton = () => {
    if (urlClick) {
      navigate(urlClick);
    }
    return;
  };

  return (
    <Box className={styles.containerListItem} onClick={handleClickButton}>
      <Box display={"flex"} width={"100%"} flexDirection={"column"} gap={1.5}>
        {iconName && (
          <Box display={"flex"}>
            <Icon sx={{ color: palette.brand, fontSize: "28px" }}>
              {iconName}
            </Icon>
          </Box>
        )}
        <Box width={"100%"}>
          <Typography className={styles.titleCardBox} sx={{ fontWeight: 600 }}>
            {title}
          </Typography>
        </Box>
      </Box>
      <Box flex={1}>
        <Typography className={styles.titleStudentCard}>
          {description}
        </Typography>
      </Box>
      <Box className={styles.barFooter}>
        <Typography sx={{ color: palette.brand, fontSize: "0.875rem" }}>
          {t("title_dialog_access")}
        </Typography>
      </Box>
    </Box>
  );
}
